import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@rq-ratings/pro-regular-svg-icons'
import { useSuspenseQuery } from '@tanstack/react-query'
import isOnline from 'is-online'
import React, { Suspense } from 'react'
import { useNetworkState } from 'react-use'

import { QUERY_KEYS } from '../../lib/queryKeys'

const NetworkStatusBarContent: React.FC = () => {
  const networkState = useNetworkState()

  const isOnlineQuery = useSuspenseQuery({
    // Use networkState.online as a query key so that when the navigator.onLine
    // property changes (navigator.onLine is used under the hood by networkState.online),
    // we can re-run the isOnline() query to determine the actual online status.
    // navigator.onLine cannot be relied upon to determine the online status.
    queryKey: QUERY_KEYS.isOnline(!!networkState.online),
    queryFn: () => isOnline(),
  })

  const isNetworkOnline = isOnlineQuery.data

  if (isNetworkOnline) {
    return null
  }

  return (
    <aside
      className="bg-danger position-fixed bottom-0 start-0 end-0 w-100 text-center p-3 text-white"
      style={{ zIndex: '10000' }}
    >
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="text-xl me-2 align-middle"
      />
      You are not connected to the internet. Please check your connection.
    </aside>
  )
}

const NetworkStatusBar: React.FC = () => (
  <Suspense fallback={null}>
    <NetworkStatusBarContent />
  </Suspense>
)

export default NetworkStatusBar
